import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://amazonmarketingdata.techlabfze.com",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor to handle expired tokens
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Token expired or invalid
      localStorage.removeItem("token");
      globalThis.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default apiClient;
